import React from "react";
import TextSkeleton from "../interfaccia/loading/TextSkeleton";
import { translationQuotaWarning } from "./translationQuota";

const format = new Intl.NumberFormat("it-IT");

export default function TranslationQuotaSummary({ total, limit, loading, error }) {
  if (loading) return <TextSkeleton lines={1} width={320} lineHeight={16} />;
  if (error) return <div role="alert">Conteggio API Google non disponibile.</div>;
  return (
    <div>
      Utilizzo API Google: {translationQuotaWarning(total, limit) && "Attenzione! "}
      <strong>{format.format(total)}</strong> char
      {limit === null
        ? " — limite non disponibile"
        : limit === Infinity
          ? " — nessun limite"
          : limit === 0
            ? " — traduzioni disattivate (limite mensile 0)"
            : ` su ${format.format(limit)}`}
      {" questo mese"}
    </div>
  );
}
